import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AngularMaterialModule } from '../../../core/modules/angular-material/angular-material.module'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { DialogPasswordComponent } from '../../../shared/components/dialog-password/dialog-password.component'
import { MatDialog } from '@angular/material/dialog'
import { LoginService } from '../../../core/services/login/login.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'forgot-form',
  imports: [AngularMaterialModule, ReactiveFormsModule, MatProgressSpinner],
  templateUrl: './forgot-form.component.html',
  styleUrl: './forgot-form.component.scss',
  standalone: true,
  providers: [LoginService, SnackbarCustomService],
})
export class ForgotFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() forgotPassword: EventEmitter<void> = new EventEmitter<void>()

  passForm: FormGroup = new FormGroup({})
  loading = false

  ngOnInit() {
    this.createForm()
  }

  createForm() {
    this.passForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    })
  }

  checkForm() {
    const email = this.passForm.get('email')?.value
    if (!email) {
      return false
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailPattern.test(email)
  }

  forgotPass() {
    this.forgotPassword.emit()
  }

  sendForgot(): void {
    this.loading = true
    const model = { email: this.passForm.get('email')?.value }
    this.loginService.recoverPassword(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.dialogSuccess()
        // this.forgotPass()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  dialogSuccess() {
    const dialogRef = this.dialog.open(DialogPasswordComponent, {
      width: '500px',
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.forgotPass()
      }
    })
  }
}
